import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Form } from "react-bootstrap";

import { useForm } from "react-hook-form";

const HeaderSection = (props) => {
  return (
    <div>
      <section className="content-header">
        <div className="section-top-header container-fluid no-padding">
          <div className="row">
            <div className="col-md-4 col-sm-4 col-xs-12 d-flex align-items-end">
              <h1>
                {props.titleIcon && <FontAwesomeIcon icon={props.titleIcon} />}{" "}
                {props.title}
              </h1>
            </div>
            {(props.icon || props.btnTitle) && (
              <div className="d-flex justify-content-end align-items-end text-right pb-2 expense-helper-btn col-md-8 col-sm-8 col-xs-12">
                <Button
                  bsPrefix="vc-generic-btn"
                  size="sm"
                  type="button"
                  onClick={() => {
                    props.handleClick(true);
                  }}
                  className="py-1 px-2 rounded f-14"
                >
                  {props.icon && (
                    <FontAwesomeIcon
                      className="header-title-icon-left"
                      icon={props.icon}
                    />
                  )}
                  {props.btnTitle}
                </Button>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export { HeaderSection };

const HeaderSection2 = (props) => {
  const { register } = useForm();
  return (
    <div>
      <section className="content-header milestone-header">
        <div className="section-top-header container-fluid no-padding border-bottom-0">
          <div className="row">
            <div className="col-md-8 col-sm-8 col-xs-12 alignment-center-set justify-content-between">
              <h1>
                {props.titleIcon && <FontAwesomeIcon icon={props.titleIcon} />}{" "}
                {props.title}
              </h1>
              <div className="alignment-center-set">
                <Form.Group className="mb-0 mr-2">
                  <Form.Control
                    // disabled={userstate.teamMembersLoading}
                    name="teamLeadId"
                    ref={register}
                    as="select"
                    onChange={(e) => {
                      let info = e.target.value.split(",");
                      props.setFilterMilestone(parseInt(info[0]));
                      props.setFilterMilestoneIndex(parseInt(info[1]));
                    }}
                  >
                    <option value={0}>{"Select Release"}</option>
                    {props.milestones &&
                      props.milestones.projectMilestones &&
                      props.milestones.projectMilestones.map(
                        (milestone, idx) => {
                          return (
                            <option
                              key={idx}
                              value={`${milestone.projectMilestoneId},${idx}`}
                            >
                              {milestone.title}
                            </option>
                          );
                        }
                      )}
                  </Form.Control>
                </Form.Group>
                {(props.icon || props.btnTitle) && (
                  <div className="">
                    <Button
                      bsPrefix="vc-generic-btn"
                      size="sm"
                      type="button"
                      onClick={() => {
                        props.setShow(true);
                      }}
                      className="py-1 px-2 rounded f-14"
                    >
                      {props.icon && (
                        <FontAwesomeIcon
                          className="header-title-icon-left"
                          icon={props.icon}
                        />
                      )}
                      {props.btnTitle}
                    </Button>
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-4 col-sm-4 col-xs-12"></div>
          </div>
        </div>
      </section>
    </div>
  );
};

export { HeaderSection2 };
